import React, { useState } from 'react';
import humanize from 'humanize-number';

import InfoButton from '../components/InfoButton';
// import InfoButtonTip from '../components/InfoButtonTipCosto';
import Sprite from '../components/Sprite';
import Tilt from '../components/Tilt';

import useStore from '../store';
import cards from '../data/cards';
import { Dialog } from '@reach/dialog';
import Modal from '../components/Modal';

import { colors } from '../config';

const Selection = props => {
  const [modal, setModal] = useState(false);

  const handleInfoClick = () => {
    setModal(!modal);
  };

  const [{ selectedGroup, selectedCard, personName }, setStore] = useStore();

  function getCards(cardId) {
    return cards?.find(card => card.id === cardId);
  }

  function getCardTypes(cardId, types) {
    return types?.find(card => card.id === cardId);
  }

  let group = getCards(selectedGroup);
  let card = getCardTypes(selectedCard, group?.types);

  const isPlatinum = card?.badge?.title === 'Platinum';

  let title = group?.title;
  let cardImage = card?.image;

  let dorada =
    (selectedGroup === 1 && (selectedCard === 2 || selectedCard === 3)) ||
    (selectedGroup === 2 && selectedCard !== 1) ||
    (selectedGroup === 3 && (selectedCard === 2 || selectedCard === 3)) ||
    (selectedGroup === 4 && selectedCard === 3);

  const getLetters = () => {
    let letters = [];

    for (let i = 0; i < personName.length; i++) {
      letters.push(<span key={i}>{personName[i]}</span>);
    }

    return letters;
  };

  return (
    <div className="selection">
      <Tilt
        options={{
          scale: 1.06,
          speed: 2000,
          max: 6,
          glare: true,
          'max-glare': 0.35,
          'full-page-listening': false,
        }}
      >
        <div className={`card-image-wrapper ${isPlatinum ? 'vertical-card' : ''}`}>
          <img src={cardImage} alt="" className={isPlatinum ? 'vertical-card' : ''} />
          {!isPlatinum && (
            <span className="fullname">
              <div className="fullname-1">{getLetters()}</div>
              <div className="fullname-2">{getLetters()}</div>
            </span>
          )}
        </div>
      </Tilt>

      <h2>
        <span>
          {card?.brand} {title}
        </span>

        <InfoButton onClick={handleInfoClick} />
      </h2>

      <dl>
        <dt>
          <Sprite icon="world" size={24} />
          <span>Compras</span>
        </dt>
        <dd>{card.features.compras}</dd>

        {card.features.ingresoMinimo && (
          <>
            <dt>
              <Sprite icon="wallet" size={24} />
              <span>Ingreso mínimo</span>
            </dt>
            <dd>${humanize(card.features.ingresoMinimo, { delimiter: '.', separator: ',' })}</dd>
          </>
        )}

        {card.features.limiteMinimo && (
          <>
            <dt>
              <Sprite icon="wallet" size={24} />
              <span>Limite mínimo</span>
            </dt>
            <dd>${humanize(card.features.limiteMinimo, { delimiter: '.', separator: ',' })}</dd>
          </>
        )}

        {/* <dt>
          <Sprite icon="money-circle" size={24} />
          <span>Crédito mínimo</span>
        </dt>
        <dd>${humanize(card.features.creditoMinimo, { delimiter: '.', separator: ',' })}</dd> */}

        <dt>
          <Sprite icon="world" size={24} />
          <span>Tipo de emisión</span>
        </dt>
        <dd>{card.features.tipoEmision}</dd>

        {/* <dt>
          <Sprite icon="plusone" size={24} />
          <span>Adicionales</span>
        </dt>
        <dd>{card.features.creditInfo}</dd> */}
      </dl>

      <hr />

      <dl>
        <dt>
          {selectedGroup === 1 || selectedGroup === 2 ? (
            <Sprite icon="plane" size={24} />
          ) : (
            <Sprite icon="star" size={24} />
          )}
          <span>
            {(selectedGroup === 1 || selectedGroup === 2) && 'Millas'}
            {selectedGroup === 3 && 'Dots'}
            {selectedGroup === 4 && 'Benefits'}
          </span>
        </dt>
        <dd>{card.features.puntos}</dd>

        <dt className="no-colon">
          <svg width={26} height={21} viewBox="0 0 26 21" fill="none">
            <path
              d="M9.196.845h7.992c.281 0 .516.101.703.304a.892.892 0 01.305.68v5.016h-1.008V1.829H9.196v18h7.992v-6h1.008v6a.992.992 0 01-.305.727.954.954 0 01-.703.28H9.196c-.281 0-.524-.093-.727-.28a1.035 1.035 0 01-.281-.727v-18c0-.266.094-.492.281-.68a.992.992 0 01.727-.304zm15.492 9h-3.492V6.329a.422.422 0 00-.164-.328.421.421 0 00-.328-.164.516.516 0 00-.375.164.45.45 0 00-.141.328v3.516h-3.492a.477.477 0 00-.492.492.477.477 0 00.492.492h3.492v3.516c0 .125.047.242.14.351a.56.56 0 00.376.14.45.45 0 00.328-.14.493.493 0 00.164-.351v-3.516h3.492c.14 0 .258-.047.352-.14a.444.444 0 00.164-.352.444.444 0 00-.165-.352.477.477 0 00-.351-.14zM1.204 5.228l6-2.813V1.313l-6.422 3a.92.92 0 00-.516.563c-.094.266-.086.523.024.773l6.914 14.813v-2.367l-6-12.867z"
              fill="#FF6200"
            />
          </svg>
        </dt>
        <dd>Sujeto a aprobación crediticia</dd>

        {/* <dt>
          <Sprite icon="money" size={24} />
          <span>Costo anual</span>
        </dt>
        <dd style={{ display: 'flex' }}>
          Primer año sin costo{' '}
          <InfoButtonTip style={{ top: -1, left: 8 }} costo={card.features.costo} />
        </dd> */}
      </dl>

      <Dialog isOpen={modal} onDismiss={() => setModal(false)} aria-label="Información adicional">
        <Modal onDismiss={() => setModal(false)} />
      </Dialog>

      <style jsx>{`
        .selection {
          float: right;
          max-width: 332px;
          padding-top: 32px;
          position: relative;
        }

        h2 {
          font-family: ${colors.baseFontDisplay};
          font-weight: 900;
          font-size: 28px;
          margin-top: 32px;
          margin-bottom: 24px;
          display: flex;
          align-items: center;
          line-height: 1.25;
        }

        h2 > span:first-child {
          margin-right: 8px;
        }

        dl {
          font-size: 16px;
          color: ${colors.brown};
        }

        dt {
          font-weight: 900;
          float: left;
          margin-right: 8px;
          display: flex;
          align-items: center;
        }

        dt span {
          margin-left: 16px;
        }

        dt:after {
          content: ':';
        }
        dt.no-colon:after {
          content: '';
        }

        dd {
          margin-bottom: 16px;
        }

        hr {
          height: 1px;
          background-color: #d9d3cf;
          border: 0;
          margin-bottom: 28px;
          margin-top: 28px;
        }

        .card-image-wrapper {
          position: relative;
          border-radius: 12px;
          overflow: hidden;
          transition: box-shadow 0.5s ease;
          /* box-shadow: 0 64px 64px 0 rgba(89, 76, 58, 0.05), 0 32px 32px 0 rgba(120, 109, 61, 0.05), */
            /* 0 16px 16px 0 rgba(82, 69, 55, 0.05), 0 8px 8px 0 rgba(125, 109, 72, 0.05), */
            /* 0 4px 4px 0 rgba(125, 114, 64, 0.05), 0 2px 2px 0 rgba(115, 102, 63, 0.05); */
        }

        .card-image-wrapper:hover {
          box-shadow: 0 72px 72px 0 rgba(89, 76, 58, 0.075), 0 48px 48px 0 rgba(120, 109, 61, 0.075),
            0 24px 24px 0 rgba(82, 69, 55, 0.075), 0 12px 12px 0 rgba(125, 109, 72, 0.075),
            0 6px 6px 0 rgba(125, 114, 64, 0.075), 0 4px 4px 0 rgba(115, 102, 63, 0.075);
        }

        .card-image-wrapper img {
          display: block;
          width: 100%;
          max-width: 332px;
          height: auto;
          border-radius: 12px;
        }

        .vertical-card {
          max-width: 170px;
        }

        .fullname {
          font-family: 'OCRAExtended', monospace;
          position: absolute;
          text-transform: uppercase;
          bottom: 16px;
          width: 280px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          left: 30px;
          font-weight: 500;
          font-size: 17px;
          /* color: ${dorada ? `#fce6af` : `#eee`}; */
          /*text-shadow: -1px 1px 1px rgba(0, 0, 0, 0.25);*/

          /* background: -webkit-linear-gradient(#fff, #999);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;

           text-shadow: 0 1px 0 #333, 0 -1px 0 #eaeaea;
          text-shadow: 0 1px 0 #cccccc, 0 2px 2px #c9c9c9, 0 3px 2px #bbb, 0 1px 2px #b9b9b9,
            0 2px 2px #aaa, 0 1px 2px rgba(0, 0, 0, 0.3);*/

          /*color: transparent;

          background: linear-gradient(
            0deg,
            #fce6af 24%,
            #504c3e 32%,
            #fbe0a5 43%,
            #fbe0a5 46%,
            #ab9870 52%,
            #fce6af 73%,
            #fbe0a5 87%,
            #fbe0a5 94%
          );

          background-size: cover;
          background-position: center;

          -webkit-background-clip: text;*/
        }

        .fullname-2 {
          color: #fff;
          ${
            dorada
              ? `text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.75), -1px -2px 2px rgba(225, 211, 140, 0.35);`
              : `text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.75), -1px -2px 2px rgba(150, 150, 150, 0.35);`
          }
        }

        .fullname-1 {
          color: transparent;
          position: absolute;
          top: 0;
          left: 0;

          ${
            dorada
              ? `background: linear-gradient(
            0deg,
            #fce6af 24%,
            #504c3e 32%,
            #fbe0a5 43%,
            #fbe0a5 46%,
            #ab9870 52%,
            #fce6af 73%,
            #fbe0a5 87%,
            #fbe0a5 94%
          );`
              : `
            background: linear-gradient(
              0deg,
              #454545 16%,
              #c8c8c8 29%,
              #ffffff 33%,
              #ffffff 43%,
              #c8c8c8 49%,
              #737373 60%,
              #ffffff 66%,
              #8f8f8f 80%
            );`
          };
          background-size: cover;
          background-position: center;
          -webkit-background-clip: text;
          z-index: 1;
        }

        .fullname {
          display: none;
        }

        @supports (-webkit-background-clip: text) {
          .fullname {
            display: block;
          }
        }

        :global(.js-tilt-glare) {
          border-radius: 12px;
        }
      `}</style>
    </div>
  );
};

export default Selection;
